// extracted by mini-css-extract-plugin
module.exports = {"loading":"media-item-info-block_loading_ocxk9"};